import React from 'react';
interface ArtDecoFrameProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'full' | 'subtle';
}
export function ArtDecoFrame({
  children,
  className = '',
  variant = 'full'
}: ArtDecoFrameProps) {
  if (variant === 'subtle') {
    return <div className={`relative p-6 ${className}`} data-id="element-22">
        <div className="deco-corner-tl" data-id="element-23" />
        <div className="deco-corner-tr" data-id="element-24" />
        <div className="deco-corner-bl" data-id="element-25" />
        <div className="deco-corner-br" data-id="element-26" />
        {children}
      </div>;
  }
  return <div className={`relative p-8 md:p-12 ${className}`} data-id="element-27">
      {/* Outer gold border */}
      <div className="absolute inset-0 border border-goldenrod/40 pointer-events-none" data-id="element-28" />
      {/* Inner gold border with gap */}
      <div className="absolute inset-2 md:inset-3 border border-goldenrod/25 pointer-events-none" data-id="element-29" />
      {/* Corner ornaments - larger */}
      <div className="deco-corner-tl-lg" data-id="element-30" />
      <div className="deco-corner-tr-lg" data-id="element-31" />
      <div className="deco-corner-bl-lg" data-id="element-32" />
      <div className="deco-corner-br-lg" data-id="element-33" />
      {/* Diamond accents at midpoints */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 text-goldenrod text-xs opacity-60" data-id="element-34">
        ◆
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 text-goldenrod text-xs opacity-60" data-id="element-35">
        ◆
      </div>
      <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 text-goldenrod text-xs opacity-60" data-id="element-36">
        ◆
      </div>
      <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 text-goldenrod text-xs opacity-60" data-id="element-37">
        ◆
      </div>
      {children}
    </div>;
}